import Axios from "axios";

const SearchVenues = async (searchTerm, token) =>
  await Axios.get(`https://api.edgevenues.com/venues/quick`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { query: searchTerm },
  });

export { SearchVenues };
